import React, { useEffect, useMemo } from 'react'
import { Group, Stack } from '@mantine/core'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'
import { TradeEntry } from './trade-entry'
import { loadTradeList } from 'app/state/ducks/trade-list/thunks'
import { loadCalendars } from 'app/state/ducks/holiday-calendars/thunks'
import { useDispatch, useSelector } from 'react-redux'
import PrimaryInput from 'app/views/components/buttons/PrimaryInput'
import { useNavigate } from 'react-router-dom'
import { TradeSearch } from './trade-search'
import { getTradeList } from 'app/state/ducks/trade-list/selectors'
import { MasterTradeParams } from 'app/models/master-trade-params'

interface props {
  tab: string
}

export function TradeManagementDrillPage({ tab }: props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const tradeList = useSelector(getTradeList)

  // The Trade List is ONE request now (GET /api/trade-list); calendars feed
  // T+. Sub trades, entities, facilities and traded facilities are loaded by
  // the row panel on expand and by the filters that need them, not up front.
  useEffect(() => {
    dispatch(loadTradeList())
    dispatch(loadCalendars())
  }, [])

  // TradeSearch matches on systemId / clientId, shows the status beside them
  // and navigates by id. The projection carries all four; the cast is because
  // the search box is typed on the full master trade it never actually reads.
  const searchRows = useMemo(
    () =>
      tradeList.map(row => ({
        id: row.id,
        systemId: row.tradeId,
        clientId: row.internalId,
        status: row.status,
      })) as unknown as MasterTradeParams[],
    [tradeList],
  )

  const tabs: { [key in props['tab']]: { route: string; label: string; active: boolean; pageRender: React.ReactNode; } } = {
    tradeEntry: { route: '/tradeentry', label: '', active: tab === 'tradeEntry' ? true : false, pageRender: <TradeEntry /> },
  }

  return (
    <Stack w="100%">
      <Group w="100%" position="apart" className='tabsGapsActivityWithTradeSearch'>
        <Group>
          <SegmentControlUpdated tabs={tabs} />
        </Group>
        <Group noWrap className="searchActionsGroup" align="center">
          <TradeSearch
            data={searchRows}
            placeholder="Trade Search"
          />
          <PrimaryInput
            onClick={() => {
              navigate('/tradeentry/create', { state: { tab: 'tradeEntryCreation' } });
            }}
            text="Create Trade"
          />
        </Group>
      </Group>
      {tabs[tab].pageRender}
    </Stack>
  )
}
